<!-- main-screen-style in style.css global -->

<section class="container-fluid main-screen">
  <app-web-navbar></app-web-navbar>

  <!-- banners -->
  <div class="banner-container position-relative">
    <swiper [config]="mainBanner">
      <ng-template *ngFor="let banner of bannerValue" swiperSlide>
        <div class="position-relative text-center">
          <img [src]="banner.image" class="img-fluid banner-img" alt="Banner Image" />
        </div>
      </ng-template>
    </swiper>
    <div class="d-none d-lg-block">
      <div class="swiper-button-prev banner-swiper-button-prev"></div>
      <div class="swiper-button-next banner-swiper-button-next"></div>
    </div>
  </div>

  <!-- Category Section - Premium Design -->
  <section class="cat-section">
    <div class="container">
      <div class="cat-section-header text-center">
        <span class="cat-badge josefin-sans-medium">🍟 Our Menu</span>
      </div>
      <div class="cat-carousel-wrap position-relative">
        <swiper [config]="categoryConfig">
          <ng-template swiperSlide>
            <div class="cat-card" (click)="showAllCategories()">
              <div class="cat-card-inner">
                <div class="cat-img-wrap">
                  <img src="assets/img/new/frost’n-crunch.png" loading="lazy" alt="All Categories">
                  <div class="cat-img-glow"></div>
                </div>
                <span class="cat-name josefin-sans-semibold">All</span>
              </div>
            </div>
          </ng-template>

          <ng-template swiperSlide *ngFor="let category of categoryDetails; let i = index">
            <div class="cat-card" (click)="changeCategory(category.categoryId)">
              <div class="cat-card-inner">
                <div class="cat-img-wrap">
                  <img [src]="this.endpoint+'/api/category/images/get/'+category.categoryId" loading="lazy"
                    [alt]="category.categoryName">
                  <div class="cat-img-glow"></div>
                </div>
                <span class="cat-name josefin-sans-semibold">{{ category.categoryName }}</span>
              </div>
            </div>
          </ng-template>
        </swiper>

        <!-- Swiper Navigation -->
        <div class="swiper-button-prev cat-swiper-button-prev"></div>
        <div class="swiper-button-next cat-swiper-button-next"></div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section - Premium Feature Cards -->
  <!-- <section class="why-choose-section">
    <div class="container">
      <div class="text-center mb-5">
        <p class="section-subtitle justify-content-center josefin-sans-medium">Why People Love Us</p>
        <h2 class="section-title-premium josefin-sans-bold">The Frost'n Crunch Promise</h2>
      </div>
      <div class="row g-4">
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">🌿</div>
            <h5 class="feature-title josefin-sans-bold">Fresh Ingredients</h5>
            <p class="feature-text josefin-sans-regular">Made with the finest quality ingredients, sourced fresh every
              day</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">⚡</div>
            <h5 class="feature-title josefin-sans-bold">Fast Delivery</h5>
            <p class="feature-text josefin-sans-regular">Quick and reliable delivery right to your doorstep</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">✨</div>
            <h5 class="feature-title josefin-sans-bold">Premium Quality</h5>
            <p class="feature-text josefin-sans-regular">Every product meets our strict quality standards</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">💰</div>
            <h5 class="feature-title josefin-sans-bold">Best Prices</h5>
            <p class="feature-text josefin-sans-regular">Competitive pricing without compromising on quality</p>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- top-products - Premium Product Cards -->
  <section class="py-5">
    <div class="container-fluid">
      <div class="row m-0 p-0">
        <div class="text-start section-header">
          <p class="section-subtitle josefin-sans-medium">Explore the Latest</p>
          <h1 class="section-title-premium josefin-sans-bold">Trending New Arrivals</h1>
        </div>
      </div>

      <!-- Swiper view - for All categories -->
      <div class="row mt-4" *ngIf="!isCategorySelected">
        <div class="position-relative px-4">
          <div class="swiper recommendedSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" *ngFor="let a of productDetails" style="height: auto !important;">
                <div class="product-card-premium" (click)="productDetailViewNavigate(a.productId)">
                  <div class="availability-badge" *ngIf="a.availability === 'Yes'">In Stock</div>
                  <div class="product-bg rounded d-flex align-items-center justify-content-center overflow-hidden">
                    <img [src]="getImageId(a.imageDetails)" loading="lazy" class="img-fluid product-image p-3"
                      [alt]="a.productName">
                  </div>
                  <div class="product-info-section">
                    <h5 class="product-name josefin-sans-semibold">{{ a.productName }}</h5>
                    <div class="product-badges">
                      <div class="weight-badge" *ngIf="a.totalQuantity">
                        <span class="weight-icon">⚖</span> {{ a.totalQuantity }} {{ a.unit || 'g' }}
                      </div>
                      <div class="pcs-badge" *ngIf="a.noOfPcsPerPkt">
                        <span class="pcs-icon">📦</span> {{ a.noOfPcsPerPkt }} pcs/pkt
                      </div>
                    </div>
                    <div class="price-row">
                      <span class="product-price josefin-sans-bold" *ngIf="a.srp">{{ a.srp }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Navigation Buttons -->
          <div class="swiper-button-prev product-swiper-button-prev"></div>
          <div class="swiper-button-next product-swiper-button-next"></div>
        </div>
      </div>

      <!-- Grid view - for specific category -->
      <div class="row mt-4 g-3 px-3" *ngIf="isCategorySelected">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let a of productDetails">
          <div class="product-card-premium h-100" (click)="productDetailViewNavigate(a.productId)">
            <div class="availability-badge" *ngIf="a.availability === 'Yes'">In Stock</div>
            <div class="product-bg rounded d-flex align-items-center justify-content-center overflow-hidden">
              <img [src]="getImageId(a.imageDetails)" loading="lazy" class="img-fluid product-image p-3"
                [alt]="a.productName">
            </div>
            <div class="product-info-section">
              <h5 class="product-name josefin-sans-semibold">{{ a.productName }}</h5>
              <div class="product-badges">
                <div class="weight-badge" *ngIf="a.totalQuantity">
                  <span class="weight-icon">⚖</span> {{ a.totalQuantity }} {{ a.unit || 'g' }}
                </div>
                <div class="pcs-badge" *ngIf="a.noOfPcsPerPkt">
                  <span class="pcs-icon">📦</span> {{ a.noOfPcsPerPkt }} pcs/pkt
                </div>
              </div>
              <div class="price-row">
                <span class="product-price josefin-sans-bold" *ngIf="a.srp">₹{{ a.srp }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</section>

<!-- footer -->
<app-web-footer></app-web-footer>